import { actionCreator } from '@ardoq/rxbeach';
import { AppModules } from 'appContainer/types';
import { AppLocation } from '../location$';
import { Trackable } from '../../../tracking/trackPayload';

export type NavigateToDeclarativeRoutePayload = {
  appModule: AppModules;
};

export const navigateToDeclarativeRoute =
  actionCreator<NavigateToDeclarativeRoutePayload>(
    '[declarative router] navigate to declarative route'
  );

export const navigate = actionCreator<Trackable<AppLocation>>(
  '[declarative router] navigate'
);

/**
 * Navigate by replacing the current history entry.
 *
 * Essentially removes the current history entry when navigating, so the back
 * button skips it.
 */
export const navigateAndReplace = actionCreator<Trackable<AppLocation>>(
  '[declarative router] replace'
);

export const navigateToParent = actionCreator(
  '[declarative router] navigate to parent'
);
